import React from 'react';
import Layout from '../../components/Layout/Layout';
import EmptyState from '../../components/EmptyState/EmptyState';
import styles from './EmptyStatePage.module.css';

const EmptyStatePage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.emptyStateGrid}>
        <EmptyState
          size="Desktop 1440"
          type="Discover SubCategory"
          categoryId={1}
        />
      </div>
    </Layout>
  );
};

export default EmptyStatePage;